<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <button
          id="show_first_results_of_filter"
          class="btn btn-default  pull-right "
          type="button"
          @click.stop="filterEvents"
        >
          {{
            trans('filters.filter_events') }}
        </button>
      </div>

      <query-builder
        class="col-xs-12"
        :model="useModel"
        :rule-id="ruleId"
        :max-depth-model="maxDepth"
        :program-id="programId"
        @queryUpdated="queryUpdated"
      />
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        {{ trans('filters.results') }} ({{ offset + (events.length) > total_events ? total_events : offset + (events.length) }} / {{ total_events > 200 ? '200+' : total_events }})
      </div>
      <div class="panel-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th> {{ trans('core.event') }}</th>
              <th> {{ trans('core.course') }}</th>
              <th> {{ trans('core.starttime') }}</th>
              <th> {{ trans('core.endtime') }}</th>
              <th> {{ trans_choice('core.groups', 2) }}</th>
              <th> {{ trans('core.type') }}</th>
            </tr>
          </thead>
          <template v-if="errors">
            <tr>
              <td
                class="alert alert-primary"
                role="alert"
                colspan="6"
              >
                {{ trans('filters.errors.no_events') }}
              </td>
            </tr>
          </template>
          <template v-else-if="loading_events">
            <tr>
              <td colspan="6">
                <i class="fa fa-spinner fa-pulse fa-2x fa-fw" />
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="event in events">
              <td><span v-safe-html="event.name" /></td>
              <td>{{ event.course_title }}</td>
              <td>{{ event.starttime }}</td>
              <td>{{ event.endtime }}</td>
              <td>{{ event.groups }}</td>
              <td>{{ event.type }}</td>
            </tr>
          </template>
        </table>

        <a
          class="btn btn-default"
          :disabled="offset === 0"
          @click="removeOffset"
        >
          Previous
        </a>
        <a
          class="btn btn-default"
          :disabled="offset > total_events - 10"
          @click="addOffset"
        >
          Next
        </a>
      </div>
    </div>

    <div
      v-if="developer"
      class="col-xs-12"
    >
      <p
        style="cursor:pointer"
        @click="changePreview"
      >
        <span
          class="fa"
          :class="preview ? 'fa-chevron-up' : 'fa-chevron-right'"
        />
        {{ trans('filters.technical_view') }}
      </p>

      <div v-if="preview">
        <pre>

                {{ formattedFilter }}
            </pre>
      </div>
    </div>
  </div>
</template>

<script>
import QueryBuilder from '../QueryBuilder.vue'

export default {
  components: {
    QueryBuilder,
  },

  props: {
    model: {
      required: true,
    },
    ruleId: {
      required: false,
      default: undefined,
    },
    programValue: {
      type: Number,
      required: false,

    },
    url: {
      type: String,
      require: false,
      default: '/admin/filterrules/applyFilter',
    },
    maxDepth: {
      required: false,
      default: 2,
    },
    includeValue: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    programDomId: {
      type: String,
    },
    modelDomId: {
      type: String,
    },
    startDateDomId: {
      type: String,
      required: false,
      default: 'a',
    },
    endDateDomId: {
      type: String,
      required: false,
      default: 'a',
    },
    startdate: {
      type: String,
      required: false,
    },
    enddate: {
      type: String,
      required: false,
    },

    includeDomId: {
      type: String,
    },
    developer: {
      type: Boolean,
      default: false,
    },
    modelTypes: {
      required: false,
      type: String,
      default: '',
    },
    extraParameters: {
      // used in scheduleSyncRules/EventFilter.vue, we give an extra parameter {type: 'class'}
      required: false,
      default: () => {},
      type: Object,
    },
  },

  data: function () {
    return {
      events: [],
      filter: null,
      errors: false,
      loading_events: false,
      debounced_filter: _.debounce(this.filterEvents, 500),
      preview: false,
      total_events: 0,
      useModel: this.model,
      offset: 0,
      programId: null,
    }
  },

  computed: {
    formattedFilter () {
      return JSON.stringify(this.filter, null, 2)
    },

    modelType () {
      return JSON.parse(this.modelTypes)
    },

  },

  methods: {
    changePreview () {
      this.preview = !this.preview
    },
    filterEvents () {
      let include = false
      let enddate = false
      let startdate = false

      if (this.programValue == null) {
        this.programId = $(this.programDomId).val()
      } else {
        this.programId = this.programValue
      }

      if (this.programId == null) {
        return
      }

      if (this.startdate == null) {
        // Check startdate
        if (this.startDateDomId != null) {
          startdate = $(this.startDateDomId).val()
        }
      } else {
        startdate = this.startdate
      }

      if (this.enddate == null) {
        // Check enddate
        if (this.endDateDomId != null) {
          enddate = $(this.endDateDomId).val()
        }
      } else {
        enddate = this.enddate
      }

      // Check include or exclude
      if (typeof this.includeValue === 'undefined') {
        include = $(this.includeDomId).is(':checked') ? 1 : 0
      } else {
        include = this.includeValue
      }

      this.errors = false
      this.loading_events = true
      axios.post(this.url, {
        program_id: this.programId,
        include: include,
        startdate: startdate,
        enddate: enddate,
        filter: this.formattedFilter,
        offset: this.offset,
        ...this.extraParameters,
      }).then((response) => {
        this.loading_events = false
        this.events = response.data.data.data // .data.data.data. ...
        this.$emit('filteredEvents', this.events)
        this.total_events = response.data.data.total_events
      }).catch(error => {
        this.errors = true
      })
    },

    queryUpdated (filter, setOffsetZero = true) {
      this.filter = filter
      this.calculateModel()

      if (setOffsetZero) {
        this.offset = 0
      }

      this.debounced_filter()

      this.$emit('queryUpdated', filter)
    },

    calculateModel () {
      // Check startdate
      if (this.modelDomId != null) {
        if (this.modelType[$(this.modelDomId).val()] !== undefined) {
          this.useModel = this.modelType[$(this.modelDomId).val()]
          this.filter.model = this.useModel
          return
        }
      }

      this.useModel = this.model
      this.filter.model = this.useModel
    },

    addOffset () {
      if (this.offset + 10 > this.total_events) {
        return
      }
      this.offset = this.offset + 10
      this.filterEvents()
    },
    removeOffset () {
      if (this.offset - 10 < 0) {
        return
      }
      const removing = this.offset % 10 !== 0 ? this.offset % 10 : 10

      this.offset = (this.offset - removing) < 0 ? 0 : this.offset - removing
      this.filterEvents()
    },

  },
}
</script>
